import { defineMessages } from 'react-intl'

export default defineMessages({
  label: {
    id: 'widgets.add-to-cart-button.label',
    defaultMessage: 'Add to cart',
  },

  notAvailable: {
    id: 'widgets.add-to-cart-button.not-available',
    defaultMessage: 'Not available',
  },

  outOfStock: {
    id: 'widgets.add-to-cart-button.out-of-stock',
    defaultMessage: 'Out of stock',
  },

  callForEnquiries: {
    id: 'widgets.add-to-cart-button.call-enquiries-hk',
    defaultMessage: 'Call for Enquiries',
  },

  packageProduct: {
    id: 'widgets.add-to-cart-button.package-product',
    defaultMessage: 'Configure your package',
  },

  notifyMe: {
    id: 'widgets.add-to-cart-button.notify-me',
    defaultMessage: 'Notify me',
  },

  addToCartButtonCustomErrorMessage: {
    id: 'widgets.add-to-cart-button.custom-error-message',
    defaultMessage:
      'Something went wrong, please reload the page, when the error persists contact customer service',
  },
  addToCartButtonUnpublishedErrorMessage: {
    id: 'widgets.add-to-cart-button.unpublished-error-message',
    defaultMessage:
       'The product is not available anymore' ,
  },
  addToCartButtonQuantityExceededErrorMessage: {
    id: "widgets.add-to-cart-button.quantity-exceeded-error-message",
    defaultMessage: 'The Quantity of product you are adding exceeded its available quantity',
  }

  
})
